<div [ngClass]="{ readonly: ReadOnly == true }">
  <div class="form-row">
    <div class="input-data">
      <div>
        <label for="">Type</label>
      </div>
      <div>
        <select name="search-parameter" id="search-parameter" style="margin-left: 0; width: 10rem">
          <ng-container *ngFor="let search of CommunicationType">
            <option>{{ search.label }}</option>
          </ng-container>
        </select>
      </div>
      <div class="underline-fixed" style="width: 10rem"></div>
    </div>
  </div>

  <div class="form-row">
    <div class="input-data">
      <div>
        <label for="">Direction</label>
      </div>
      <div>
        <select name="search-parameter" id="search-parameter" style="margin-left: 0; width: 10rem">
          <ng-container *ngFor="let search of CommunicationDirection">
            <option>{{ search.label }}</option>
          </ng-container>
        </select>
      </div>
      <div class="underline-fixed" style="width: 10rem"></div>
    </div>
  </div>
  <div class="form-row">
    <div>
      <button class="outline-btn ms-3" (click)="goCompose()">Compose</button>
    </div>
  </div>
</div>

<div class="info">
  <div class="cases">
    <!-- <div class="search">
      <div class="container" style="margin: 0; padding: 0; width: 13.125rem">
        <input type="text" [(ngModel)]="searchValue" class="search-box" style="width: 84%" />
        <button class="search-btn" (click)="searchCases()">
          <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
        </button>
      </div>
    </div> -->
    <!-- <div style="
        text-align: left;
        font-weight: bold;
        font-size: 0.688rem;
        line-height: 0.813rem;
        font-family: Gellix;
        letter-spacing: 0rem;
        color: #97999b;
        opacity: 1;
        padding-top: 1.25rem;
        padding-left: 0.625rem;
        padding-bottom: 0.625rem;
      ">
      1 to {{ caseDataPerPage.length }} of {{ caseData.length }} matching cases
    </div> -->

    <div
      *ngFor="let item of CommunicationHistoryDetail"
      (click)="selectItem(item.ID)"
      class="date-main"
      [class.active]="item.ID === selectItemid"
    >
      <span *ngIf="item.Successful === true" class="date-dotSuccess"></span>
      <span *ngIf="item.Pending === true" class="date-dot"></span>
      <span class="date-data"
        >{{ item.Recipient }}
        <br />
        ({{ item.Sent | custdate }})</span
      >

      <span class="date-arrow" [class.open]="item.ID === selectItemid"> </span>
      <div class="underline-fixedHistory" style="width: 14rem"></div>
      <hr style="height: 0rem; margin: 0; border: none; border-top: 0.063rem solid #dfdfdf" />
    </div>

    <!-- <div class="flex-1">
      <p-paginator (onPageChange)="onPageChange1($event)" [first]="first1" [rows]="rows1" [totalRecords]="totalRecords"
        [showJumpToPageDropdown]="false" [showFirstLastIcon]="false">
      </p-paginator>
    </div> -->
  </div>

  <div class="case-details" *ngIf="showGetfaxAll">
    <div class="container-fluid" style="height: 1.125rem; padding: 0">
      <div
        style="
          text-align: left;
          font-weight: bold;
          font-size: 0.938rem;
          line-height: 1.125rem;
          font-family: Gellix;
          letter-spacing: 0rem;
          color: #000048;
          opacity: 1;
          float: left;
        "
      >
        <!-- Fax Detail -->
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-3"><label for="">To</label></div>
            <div class="col-3">
              <label for="">
                {{ getFaxDetail?.RecipientName }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-6"></div>
        <div class="col-6">
          <div class="row">
            <div class="col-3"><label for="">From</label></div>
            <div class="col-3">
              <label for="">
                {{ getFaxDetail?.SenderName }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-6"></div>
        <div class="col-6">
          <div class="row">
            <div class="col-3"><label for="">Sent</label></div>
            <div class="col-3">
              <label for="">{{ getFaxDetail?.RequestedAt | custdate }}</label>
            </div>
          </div>
        </div>
        <div class="col-6"></div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-3"></div>
          <div class="col-3" style="padding-left: 4rem">
            <label for="">Status: </label>
            <label class="font-size: medium; color: black;" for="">{{ getFaxDetail?.Success }}</label>
          </div>
        </div>
        <div class="underline-fixedline" style="padding-left: 40.5rem; margin-bottom: 12.5px"></div>
        <div class="col-6">
          <div class="row">
            <div class="col-3">
              <label for="">Attachments({{ getFaxDetailwithAllFile?.length }})</label>
            </div>
            <div class="col-3">
              <!-- <label for="">{{ getFaxDetailwithAllFile?.length }}</label> -->
            </div>
          </div>
        </div>
        <div class="col-6">
          <span class="close" (click)="closeTask()">X</span>
        </div>

        <div class="underline-fixedline" style="padding-left: 40.5rem; margin-top: 12.5px"></div>
        <div class="col-6" *ngFor="let item of getFaxDetailwithAllFile">
          <div class="row">
            <!-- <div class="col-2"><label for="">Sent</label></div> -->
            <div class="col-2">
              <span (click)="getFilesDetails(item.FileLocation)">
                <label class="file-label" for="">{{ item.FileName }}</label>
              </span>
            </div>
          </div>
        </div>
        <div class="col-6"></div>

        <div class="row" *ngIf="safeUrl">
          <div>
            <iframe [src]="safeUrl" width="100%" height="500px"> </iframe>
          </div>
        </div>
        <div class="row" *ngIf="imageSrc">
          <div>
            <img [src]="imageSrc" width="100%" height="500px" />
          </div>
        </div>
        <div class="row" *ngIf="imageSrcJpeg">
          <div>
            <img [src]="imageSrcJpeg" width="100%" height="500px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div class="mb3" style="margin-right: 720px" *ngFor="let item of CommunicationHistoryDetail">
    <p-panel
      [toggleable]="true"
      [collapsed]="!collapseAll"
      [collapseIcon]="'pi pi-plus-circle'"
      [expandIcon]="'pi pi-minus-circle'"
    >
      <ng-template pTemplate="header">
        <div>
          <p
            style="
              text-align: left;
              font-weight: bold;
              font-size: 0.75rem;
              line-height: 0.875rem;
              font-family: Gellix, sans-serif;
              letter-spacing: 0rem;
              padding-top: 1.25rem;
              color: #53565a;
              opacity: 1;
            "
          >
            {{ item.Recipient }}
            <br />
            {{ item.Sent }}

           
          </p>
        </div>
      </ng-template>
       </p-panel>
  </div>

 
</div> -->
